import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { CoinWindow } from '@/api/types';
import { safeStorage } from './storage';

export type Currency = 'usd' | 'sol';
export type ExploreView = 'grid' | 'table';

export interface SettingsState {
  /** Slippage tolerance for trades and the dev buy, in basis points (sent as slippageBps on every build). */
  slippageBps: number;
  /** Quick-buy amount in SOL (Explore). */
  quickBuySol: string;
  currency: Currency;
  homeWindow: CoinWindow;
  exploreView: ExploreView;
  set: (patch: Partial<Omit<SettingsState, 'set'>>) => void;
}

/** The server accepts 0..5000. There is no priority-fee setting: on mainnet the server estimates it per transaction. */
export const SLIPPAGE_PRESETS = [100, 300, 500, 1000] as const;

export const useSettings = create<SettingsState>()(
  persist(
    (set) => ({
      slippageBps: 500,
      quickBuySol: '0.5',
      currency: 'usd',
      homeWindow: '1h',
      exploreView: 'grid',
      set: (patch) => set(patch),
    }),
    { name: 'zefiro.settings.v1', storage: safeStorage, partialize: ({ set: _set, ...rest }) => rest },
  ),
);
